// Deterministic name→color hashing so the same contact always gets
// the same avatar background across renders + reloads. 12 hand-picked
// palette swatches that contrast well with white text.

const PALETTE = [
  '#6366F1', '#8B5CF6', '#EC4899', '#F43F5E', '#F97316',
  '#EAB308', '#10B981', '#14B8A6', '#06B6D4', '#0EA5E9',
  '#3B82F6', '#4F46E5',
];

export function avatarColor(input: string | null | undefined): string {
  const s = (input ?? '').trim() || 'anon';
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function initialsOf(input: string | null | undefined): string {
  const s = (input ?? '').trim();
  if (!s) return '?';
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
